angular.module('app').component('adminSeparator', {
    templateUrl: 'events/components/separator.html',
    bindings: {
        color: '@?'
    }
});
